module.exports = __webpack_public_path__ + "static/assets/b01ef4275aa3ea0fc3ea2f47cfb4df25.png";